import { InputSignal, Signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDatiqGeoSuggestion } from '@dat/iq-proxy';

export interface IIqControlTextStateService {
    percent(
        name: InputSignal<string>,
        value: InputSignal<number>,
        fg: FormGroup<any>,
        {
            disabled,
            minValue,
            maxValue,
            required,
        }: {
            disabled: InputSignal<boolean>;
            minValue: InputSignal<number>;
            maxValue: InputSignal<number>;
            required: InputSignal<boolean>;
        },
    ): Signal<number>;

    geoSuggestions(
        queryValue: InputSignal<string>,
    ): Signal<Promise<IDatiqGeoSuggestion[]>>;

    integer(
        name: InputSignal<string>,
        value: InputSignal<number>,
        fg: FormGroup<any>,
        arg3: {
            disabled: InputSignal<boolean>;
            minValue: InputSignal<number>;
            maxValue: InputSignal<number>;
            required: InputSignal<boolean>;
        },
    ): Signal<number>;
}

export enum GeoControlEventTypes {
    Select = 'select',
    Deselect = 'deselect',
    Submit = 'submit',
}